import { ClaimMethod } from './types';

export const parseClaimMethod = (value?: string): ClaimMethod | undefined => {
  if (value === String(ClaimMethod.QR_SCAN)) {
    return ClaimMethod.QR_SCAN;
  }

  if (value === String(ClaimMethod.MANUAL)) {
    return ClaimMethod.MANUAL;
  }

  return undefined;
};

export const firstRouteParam = (value?: string | string[]): string | undefined => {
  const param = Array.isArray(value) ? value[0] : value;
  return param || undefined;
};

export const resolveClaimRouteParams = (
  local: Partial<Record<'code' | 'transaction_date' | 'method', string | string[]>>,
  global: Partial<Record<'code' | 'transaction_date' | 'method', string | string[]>>
) => ({
  code: firstRouteParam(local.code) ?? firstRouteParam(global.code),
  transaction_date:
    firstRouteParam(local.transaction_date) ?? firstRouteParam(global.transaction_date),
  method: firstRouteParam(local.method) ?? firstRouteParam(global.method),
});
